import { getAssets, getAllAssets, getReferenceCurrency, getDepositAddress } from '../../../apis/assets'
import { FETCH_ASSETS_START, FETCH_AVAILABLE_ASSETS_START, FETCH_DEPOSIT_ADDRESS_START, FETCH_REFERENCE_CURRENCY_START } from './actionTypes'
import { takeEvery, call, fork, all, put } from 'redux-saga/effects'
import { 
  getAssetsSuccess, 
  getAvailableAssetsSuccess, 
  getAvailableAssetsError,
  getReferenceCurrencyError, 
  getReferenceCurrencySuccess,
  getDepositAddressSuccess,
  getDepositAddressError,
} from './actions'

function* fetchAssets() {
  try {
    const result = yield call(getAssets)
    yield put(getAssetsSuccess(result))
  } catch (error) {}
}

function* watchAssets() {
  yield takeEvery(FETCH_ASSETS_START, fetchAssets)
}

function* fetchReferenceCurrency() {
  try {
    const result = yield call(getReferenceCurrency)
    yield put(getReferenceCurrencySuccess(result))
  } catch (error) {
    yield put(getReferenceCurrencyError(error.message))
  }
}
function* fetchDepositAddress(action) {
  try {
    const { currency, chain } = action.payload
    const result = yield call(getDepositAddress, currency, chain) 
    yield put(getDepositAddressSuccess(result))
  } catch (error) {
    yield put(getDepositAddressError(error.message))
  }
}
function* watchReferenceCurrency() {
  yield takeEvery(FETCH_REFERENCE_CURRENCY_START, fetchReferenceCurrency)
}

// Saga for fetching available assets from root endpoint
function* fetchAvailableAssets() {
  try {
    const result = yield call(getAllAssets)
    yield put(getAvailableAssetsSuccess(result))
  } catch (error) {
    yield put(getAvailableAssetsError(error.message))
  }
}

function* watchAvailableAssets() {
  yield takeEvery(FETCH_AVAILABLE_ASSETS_START, fetchAvailableAssets)
}

function* watchDepositAddress() {
  yield takeEvery(FETCH_DEPOSIT_ADDRESS_START, fetchDepositAddress)
}

function* assetsSaga() {
  yield all([
    fork(watchAssets),
    fork(watchAvailableAssets),
    fork(watchReferenceCurrency),
    fork(watchDepositAddress)
  ])
}
export default assetsSaga
